import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
const faqs = [{
  question: '¿Realmente entregan en 5 días?',
  answer: 'Sí. Nuestro método combina herramientas de inteligencia artificial con un equipo experto en marketing digital. Optimizamos cada paso del proceso para entregar resultados en tiempo récord sin sacrificar calidad.'
}, {
  question: '¿Para qué tipo de negocios funciona?',
  answer: 'Trabajamos con todo tipo de negocios y profesionales: restaurantes, clínicas, abogados, consultores, arquitectos, coaches, tiendas y más. Si tenés un negocio y querés más clientes, esto es para vos.'
}, {
  question: '¿Qué son las imágenes DTC para Meta Andromeda?',
  answer: 'Son diseños publicitarios creados específicamente en formato DTC (Direct-To-Consumer) y optimizados para el algoritmo Meta Andromeda, que es el sistema de inteligencia artificial que Meta usa para mostrar tus anuncios a las personas correctas. Estas imágenes están diseñadas estratégicamente con los colores, textos y formatos que mejor funcionan para captar la atención de clientes potenciales en Facebook e Instagram.'
}, {
  question: '¿Por qué recibo diferente cantidad de imágenes en cada plan?',
  answer: 'En el plan Página Web recibís 5 imágenes DTC listas para usar en tus redes o publicidad. En el plan Página Web + Meta Ads recibís 10 imágenes para que podás ir rotándolas en tus campañas y mantener la publicidad fresca. En el plan Crecimiento Continuo, nosotros nos encargamos de rotar y renovar los creativos cada mes según las métricas de tu campaña — los que mejor funcionan se mantienen y los que no, se reemplazan por nuevos diseños.'
}, {
  question: '¿Puedo usar las imágenes DTC en mis redes sociales también?',
  answer: 'Sí, las imágenes son tuyas. Podés usarlas en tus publicaciones de Instagram, Facebook, WhatsApp, o donde quieras. Están diseñadas para verse profesionales tanto en anuncios pagados como en publicaciones orgánicas.'
}, {
  question: '¿Por qué tengo que pagar pauta en Meta aparte?',
  answer: 'La pauta es el dinero que Meta (Facebook e Instagram) cobra para mostrar tus anuncios a clientes potenciales. Ese dinero NO se queda con nosotros — va 100% a la plataforma para que tus anuncios lleguen a personas reales en tu zona. Nosotros cobramos por el servicio de crear, configurar y optimizar tu campaña. La pauta es la gasolina que hace que tus anuncios corran, y vos decidís cuánto invertir según tu presupuesto y objetivos.'
}, {
  question: '¿Cuánto me recomiendan de pauta en Meta para iniciar?',
  answer: 'Para negocios en Costa Rica, recomendamos iniciar con un mínimo de $100-$150 USD mensuales. Con ese monto podés alcanzar entre 5,000 y 15,000 personas en tu zona cada mes. Si querés resultados más agresivos, con $200-$300 USD mensuales vas a ver un flujo constante de clientes nuevos. Lo bueno es que podés empezar con poco, ver resultados, y luego ir aumentando conforme tu agenda se llena.'
}, {
  question: '¿Qué pasa si no quiero pautar en Meta?',
  answer: 'Podés elegir el plan Página Web sin campaña de Meta Ads. Tu página igual va a funcionar 24/7 y podés compartir el link en tus redes sociales, WhatsApp y Google. Además, recibís 5 imágenes DTC que podés usar en tus publicaciones orgánicas. Sin embargo, la combinación de página web + Meta Ads es donde se ven los mejores resultados.'
}, {
  question: '¿Qué pasa si no me gusta el diseño?',
  answer: 'Incluimos hasta 2 rondas de revisiones para asegurar que el resultado final refleje la imagen profesional de tu negocio. Trabajamos contigo hasta que estés 100% satisfecho.'
}, {
  question: '¿Incluye el dominio y hosting?',
  answer: 'Sí, el primer año de dominio y hosting está incluido en tu inversión. Nosotros nos encargamos de toda la configuración técnica para que vos te enfoques en atender a tus clientes.'
}, {
  question: '¿Cómo es el proceso de pago?',
  answer: 'Aceptamos transferencia bancaria (BAC, Banco Popular o Banco Nacional) y SINPE Móvil. El 50% se paga al inicio para comenzar el proyecto y el 50% restante al entregar tu página web terminada.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" className="py-24 bg-[#050510]" data-id="element-83">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-84">
        <div className="text-center mb-16" data-id="element-85">
          <h2 className="text-3xl md:text-5xl font-bold font-orbitron mb-4" data-id="element-86">
            Preguntas <span className="text-gradient-cosmic" data-id="element-87">Frecuentes</span>
          </h2>
          <p className="text-gray-400" data-id="element-88">
            Resolvemos tus dudas para que tomes la mejor decisión.
          </p>
        </div>

        <div className="space-y-4" data-id="element-89">
          {faqs.map((faq, index) => <div key={index} className="border border-white/10 rounded-xl bg-[#0a0a1a] overflow-hidden transition-all duration-300 hover:border-purple-500/30" data-id="element-90">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-91">
                <span className="text-lg font-medium text-white pr-8" data-id="element-92">
                  {faq.question}
                </span>
                {openIndex === index ? <Minus className="w-5 h-5 text-purple-500 flex-shrink-0" data-id="element-93" /> : <Plus className="w-5 h-5 text-gray-500 flex-shrink-0" data-id="element-94" />}
              </button>
              <AnimatePresence data-id="element-95">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-96">
                    <div className="px-6 pb-6 text-gray-400 leading-relaxed" data-id="element-97">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}